import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { PATH } from '../../../constants/path';
import { STATIC_ROOT } from '../../../constants';

import { logoutUser } from '../../../services/authentication/logout/actions';

import { getClientUrl } from '../../../utils/ssoUtil';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import SvgComponent from '../../SvgComponent';

class LogoutButtonComponent extends React.Component {
    render() {
        const { isText, className, text, ariaLabel, logoutUser, location, history } = this.props;

        const callback = new RegExp(PATH.ACCOUNT_PATH).test(location.pathname)
            ? () => history.push('/')
            : null;

        if (isText) {
            return (
                <div className="logout-wrapper">
                    <button
                        type="button"
                        aria-label={convertHtmlToReactDomWithParams(ariaLabel, getClientUrl())}
                        className={className}
                        onClick={() => logoutUser(callback)}>
                        {text}
                    </button>
                </div>
            );
        } else {
            return (
                <button
                    type="button"
                    className={className}
                    onClick={() => logoutUser(callback)}>
                    <SvgComponent
                        src={`${STATIC_ROOT}/deconnexion.svg`}
                        width="16"
                        height="17"
                        aria-hidden="true"
                        focusable="false"
                    />
                </button>
            );
        }
    }
}

LogoutButtonComponent.propTypes = {
    className: PropTypes.string,
    isText: PropTypes.bool
};

export default withRouter(connect(null, { logoutUser })(LogoutButtonComponent));



// WEBPACK FOOTER //
// ./src/components/authentication/logout/LogoutButtonComponent.js